var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxtf-dialog",
    {
      attrs: {
        "append-to-body": "",
        visible: _vm.show,
        width: "520px",
        "custom-class": "text-center yxtbiz-gratuity",
      },
      on: {
        "update:visible": function ($event) {
          _vm.show = $event
        },
        close: _vm.close,
        closed: _vm.closed,
      },
    },
    [
      _vm.initing
        ? _c("i", {
            directives: [
              {
                name: "floading",
                rawName: "v-floading",
                value: _vm.initing,
                expression: "initing",
              },
            ],
            staticClass: "yxtbiz-ds-initing pa z-19 right-top over-hidden",
          })
        : _vm._e(),
      _vm.requestErrorText
        ? _c(
            "div",
            { staticClass: "yxtbiz-ds-empty" },
            [
              _c("yxtf-empty", {
                attrs: {
                  size: "small",
                  permission: "",
                  "empty-text": _vm.requestErrorText,
                },
              }),
            ],
            1
          )
        : [
            _c("yxtf-portrait", {
              staticClass: "mt16",
              attrs: {
                size: "88px",
                "img-url": _vm.imgUrl,
                username: _vm.targetUserInfo.fullname,
              },
            }),
            _vm.anonymous === 0
              ? _c(
                  "yxt-tooltip",
                  {
                    attrs: {
                      placement: "top",
                      "open-filter": true,
                      "popper-class": "yxtbiz-ds-dept",
                      effect: "light",
                    },
                  },
                  [
                    _c(
                      "div",
                      { attrs: { slot: "content" }, slot: "content" },
                      [
                        _c("yxtbiz-user-name", {
                          attrs: { name: _vm.targetFullName },
                        }),
                        _vm.targetUserInfo.deptName
                          ? [
                              _vm._v("-"),
                              _c("yxtbiz-dept-name", {
                                attrs: { name: _vm.targetUserInfo.deptName },
                              }),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "yxtbiz-ds-name font-size-16 nowrap ellipsis",
                      },
                      [
                        _vm._v(
                          "\n        " + _vm._s(_vm.$t("pc_biz_lbl_gratuity"))
                        ),
                        _c("yxtbiz-user-name", {
                          attrs: { name: _vm.targetFullName },
                        }),
                        _vm.targetUserInfo.deptName
                          ? [
                              _vm._v("-"),
                              _c("yxtbiz-dept-name", {
                                attrs: { name: _vm.targetUserInfo.deptName },
                              }),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]
                )
              : _vm._e(),
            _c("div", { staticClass: "yxtbiz-ds-tip mt8 text-8c" }, [
              _vm._v(_vm._s(_vm.$t("pc_biz_lbl_gratuitytip"))),
            ]),
            _c(
              "div",
              {
                staticClass: "yxtbiz-ds-options",
                class: { "text-left": _vm.options.length > 2 },
              },
              [
                _vm.onlyOne.btn
                  ? _c(
                      "div",
                      { staticClass: "yxtbiz-ds-only-btn pt24 lh40 text-26" },
                      [
                        _vm._v(
                          _vm._s(_vm.options[0].pointValue) +
                            _vm._s(_vm.$t("pc_biz_enroll_lbl_integral"))
                        ),
                      ]
                    )
                  : _vm._l(_vm.options, function (item, index) {
                      return _c(
                        "span",
                        {
                          key: item.id,
                          staticClass: "yxtbiz-ds-option d-in-block v-top",
                          class: {
                            "yxtbiz-ds-selected color-primary-6": item.select,
                            "yxtbiz-ds-only-input": _vm.onlyOne.input,
                            pb24:
                              index === _vm.options.length - 1 &&
                              item.switchType !== 1,
                          },
                        },
                        [
                          item.switchType !== 1
                            ? _c(
                                "yxtf-button",
                                {
                                  attrs: { plain: "", disabled: item.disabled },
                                  on: {
                                    click: function ($event) {
                                      return _vm.selectOptionHandle(index)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "mr4 font-size-18 v-mid text-26 font-bolder",
                                      class: { "text-26": !item.select },
                                    },
                                    [_vm._v(_vm._s(item.pointValue))]
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "font-size-12 v-mid" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("pc_biz_enroll_lbl_integral")
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : _c(
                                "span",
                                {
                                  staticClass:
                                    "yxtbiz-ds-input pb24 d-in-block pr",
                                },
                                [
                                  _c("yxtf-input", {
                                    ref: "input",
                                    refInFor: true,
                                    class: _vm.inputScore
                                      ? "font-size-18"
                                      : "font-size-12",
                                    attrs: {
                                      disabled: item.disabled,
                                      placeholder: _vm.$t(
                                        "pc_biz_lbl_custompoint"
                                      ),
                                    },
                                    on: {
                                      focus: function ($event) {
                                        return _vm.inputHandle("focus")
                                      },
                                      blur: function ($event) {
                                        return _vm.inputHandle("blur")
                                      },
                                    },
                                    model: {
                                      value: _vm.inputScore,
                                      callback: function ($$v) {
                                        _vm.inputScore = $$v
                                      },
                                      expression: "inputScore",
                                    },
                                  }),
                                  _vm.inputMsg
                                    ? _c(
                                        "label",
                                        {
                                          staticClass:
                                            "pa z-19 font-size-12 text-8c custom-label--nowrap",
                                          class: _vm.inputLabelPosition,
                                        },
                                        [_vm._v(_vm._s(_vm.inputMsg))]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                        ],
                        1
                      )
                    }),
              ],
              2
            ),
            _c(
              "div",
              { staticClass: "yxtbiz-ds-sure-btn pr" },
              [
                !_vm.preview && _vm.showError
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "pa z-19 width-percent-100 lh20 font-size-12 yxtf-color-danger",
                      },
                      [_vm._v(_vm._s(_vm.$t("pc_biz_lbl_pointinsufficient")))]
                    )
                  : _vm._e(),
                _c(
                  "yxtf-button",
                  {
                    attrs: {
                      type: "primary",
                      size: "others",
                      loading: _vm.submiting,
                      disabled: _vm.btnDisabled,
                    },
                    on: { click: _vm.sureHandle },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("pc_biz_lbl_gratuity")) +
                        "\n      "
                    ),
                  ]
                ),
              ],
              1
            ),
            _c("div", { staticClass: "mv8 font-size-12 text-8c" }, [
              _c("span", [
                _vm._v(
                  _vm._s(_vm.$t("pc_biz_lbl_enablepoint")) +
                    "：" +
                    _vm._s(_vm.totalMallPoint.toLocaleString())
                ),
              ]),
              _vm.limitSwitch === 1
                ? _c("span", { staticClass: "ml20" }, [
                    _vm._v(
                      _vm._s(_vm.cycleText) +
                        _vm._s(_vm.$t("pc_biz_lbl_remaintime")) +
                        "：" +
                        _vm._s(_vm.surplusRewardTimes) +
                        _vm._s(_vm.$t("pc_biz_ote_lbl_time"))
                    ),
                  ])
                : _vm._e(),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }